import { render, staticRenderFns } from "./BaseDescriptionListItem.vue?vue&type=template&id=52e279e2&scoped=true"
var script = {}
import style0 from "./BaseDescriptionListItem.vue?vue&type=style&index=0&id=52e279e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e279e2",
  null
  
)

export default component.exports